import React from 'react';

const lastThumbnailClick = (props, elemIndex) => {
  props.onLastThumbnailClick(elemIndex);
};

const CarouselThumbnail = props => {
  let imageUrl = props.imageUrl,
    morePhotosInfo = props.elemIndex === props.lastThumbnailIndex,
    morePhotosCounter = props.imgCount - props.lastThumbnailIndex + 1,
    elemIndex = props.elemIndex || 0,
    style = {
      backgroundImage: 'url(' + imageUrl + ')'
    };
  return (
    <div
      className={`carousel-thumbnail ${morePhotosInfo ? 'more-photos' : ''}`}
      data-element-index={elemIndex}
      onClick={
        morePhotosInfo
          ? lastThumbnailClick.bind(this, props, elemIndex)
          : props.onThumbnailClick
      }
      key={elemIndex}
      style={style}
    >
      {morePhotosInfo && (
        <div className="more-photos-content">
          <div className="content-wrapper">
            <i className="fa">+</i>
            <span className="counter">{morePhotosCounter}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarouselThumbnail;



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/gallery/carousel_thumbnail.jsx